import { ComponentLookup } from '@/ui-kit/domain/ComponentLookup';
import ComponentSwitch from '@/UiBuilder/elements/ComponentSwitchCfgUIElement/ComponentSwitchCfgUIElement';
import { IUICfgComponent, IUICfgComponentElementOptions } from '@canvas-logic/clp-api-types';

type IProps = {
  lookup: ComponentLookup;
  viewElement: IUICfgComponent;
};
export const ComponentCfgUIElement = ({ lookup, viewElement }: IProps) => {
  return <ComponentSwitch lookup={lookup} viewElement={viewElement} />;
};
